import axios from 'axios'
import _ from 'lodash';


export default {
  async deleteFile(fileID) {
    const response = await axios.delete(`/api/admin/files/${fileID}`);
    return response.data;
  },
  async getLegacySlides(presentationID) { // MLD-5247
    const response = await axios.get(`/api/presentations/${presentationID}/legacy-slides`);
    return response.data;
  },
  async getFiles(presentationID) {
    const response = await axios.get(`/api/presentations/${presentationID}/files`);
    return response.data;
  },
  async getFile(fileID) {
    const response = await axios.get(`/api/admin/files/${fileID}`);
    let file = response.data;
    this.setEditability(file);
    return file;
  },
  async getFileContent(fileID) {
    const response = await axios.get(`/api/admin/files/${fileID}/content`);
    return response.data.content;
  },
  async saveFileContent(fileID, form) {
    const response = await axios.put(`/api/admin/files/${fileID}/content`, form);
    return response.data;
  },
  setEditability(file) {
    if (_.isObject(file) && _.isString(file.mime_type)) {
      switch (file.mime_type) {
        case 'application/x-javascript':
        case 'application/xml':
        case 'application/json':
        case 'text/css':
        case 'text/html':
        case 'text/plain':
        case 'text/xml':
          file.editable = true;
          break;
        default:
          file.editable = false;
      }
    }
  }
}
